import { Button } from '@cian/ui-kit/button';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

export interface INewbuildingCallButtonProps {
  onClick(): void;
}

export const NewbuildingCallButton: React.FC<INewbuildingCallButtonProps> = ({ onClick }) => {
  return (
    <Button
      fullWidth
      size="M"
      theme="fill_primary"
      beforeIcon={<IconCommunicationPhone16 color="icon-on-bright-default" />}
      onClick={onClick}
      data-name="NewbuildingCallButton"
      data-testid="NewbuildingCallButton"
    >
      Позвонить застройщику
    </Button>
  );
};
